



//const Serverurl= ["https://app.mmcoachingmysuru.com/appfiles/"]
//const Serverurl= ["http://localhost/xampp/apoorva/mmcoaching/mmc/"]

const Serverurl= ["https://app.mmcoachingmysuru.com/appfiles/"]


export default Serverurl;






